import 'bootstrap/dist/css/bootstrap.min.css';
import { CaseStudies, Contact, Footer, Hero, Process, Services, CTA } from './container';
import { Menu } from './components';

const App = () => (
  <div className="site-shell">
    <Menu />
    <main>
      <Hero />
      <CTA />
      <Services />
      <CaseStudies />
      <Process />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default App;
